<template>
    <div>
        <sweet-modal blocking :title="state === 'create' ? $t('modal_humanCapitalManagement_addItem') : $t('modal_humanCapitalManagement_editItem')" ref="addHumanCapitalItemModal" class="add-item-modal" v-on:close="close">
            <el-form label-position="left" :model="formAddItem" status-icon :rules="rules" ref="formAddItem" class="add-item-form">
                <el-form-item size="mini" prop="type">
                    <el-select v-model="formAddItem.type" :placeholder="$t('modal_humanCapitalManagement_scheduleType')" style="width:100%;">
                        <el-option
                                v-for="item in schedules"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item size="mini" prop="hoursOrdinaryCode">
                    <el-input :placeholder="$t('modal_humanCapitalManagement_hoursOrdinaryCode')" v-model="formAddItem.hoursOrdinaryCode"></el-input>
                </el-form-item>
                <el-form-item size="mini" prop="name">
                    <el-input :placeholder="$t('modal_humanCapitalManagement_name')" v-model="formAddItem.name"></el-input>
                </el-form-item>
                <el-form-item size="mini" prop="description">
                    <el-input
                            type="textarea"
                            :rows="2"
                            :placeholder="$t('modal_humanCapitalManagement_addItemDescription')"
                            v-model="formAddItem.description">
                    </el-input>
                </el-form-item>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div style="margin: 20px 0;">
                            {{$t('modal_humanCapitalManagement_addItemTimekeepingDetails')}}
                        </div>
                        <el-form-item label-width="80px" label-position="left" :label="$t('modal_humanCapitalManagement_addItemhours')" size="mini" prop="hours">
                            <el-input type="number" :placeholder="$t('modal_humanCapitalManagement_addItemhours')" v-model="formAddItem.hours"></el-input>
                        </el-form-item>
                        <el-form-item label-width="80px"  label-position="left" :label="$t('modal_humanCapitalManagement_addItemSomeDay')" size="mini" prop="someDay">
                            <el-select v-model="formAddItem.someDay" :placeholder="$t('modal_humanCapitalManagement_addItemSomeDay')" style="width:100%;">
                                <el-option
                                        v-for="item in someDayList"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <div style="margin: 20px 0;">
                            {{$t('modal_humanCapitalManagement_addItemPayrollDetails')}}
                        </div>
                        <el-form-item label-width="120px" label-position="left" :label="$t('modal_humanCapitalManagement_addItemNameOfPayslip')" size="mini" prop="nameOfPayslip">
                            <el-input disabled :placeholder="$t('modal_humanCapitalManagement_addItemNameOfPayslip')" v-model="formAddItem.nameOfPayslip"></el-input>
                        </el-form-item>
                        <el-form-item label-width="80px" label-position="left" :label="$t('modal_humanCapitalManagement_addItemRateType')" size="mini" prop="rateType">
                            <el-input disabled :placeholder="$t('modal_humanCapitalManagement_addItemRateType')" v-model="formAddItem.rateType"></el-input>
                        </el-form-item>
                        <el-form-item label-width="150px" label-position="left" :label="$t('modal_humanCapitalManagement_addItemMultiplierOfHourlyRate')" size="mini" prop="multiplierOfHourlyRate">
                            <el-checkbox disabled v-model="formAddItem.multiplierOfHourlyRate"></el-checkbox>
                        </el-form-item>
                        <el-form-item label-width="80px" label-position="left" :label="$t('modal_humanCapitalManagement_addItemMultiplyBy')" size="mini" prop="multiplyBy">
                            <el-input disabled :placeholder="$t('modal_humanCapitalManagement_addItemMultiplyBy')" v-model="formAddItem.multiplyBy"></el-input>
                        </el-form-item>
                        <el-form-item label-width="80px" label-position="left" :label="$t('modal_humanCapitalManagement_taxType')" size="mini" prop="taxType">
                            <el-input disabled :placeholder="$t('modal_humanCapitalManagement_taxType')" v-model="formAddItem.taxType"></el-input>
                        </el-form-item>
                        <div style="margin-bottom:10px;">
                            {{$t('modal_humanCapitalManagement_addItemAccountsFor')}}
                        </div>
                        <el-form-item label-width="80px" label-position="left" :label="$t('modal_humanCapitalManagement_addItemExpenditure')" size="mini" prop="expenditure">
                            <el-input disabled :placeholder="$t('modal_humanCapitalManagement_addItemExpenditure')" v-model="formAddItem.expenditure"></el-input>
                        </el-form-item>
                        <el-form-item label-width="80px" label-position="left" :label="$t('modal_humanCapitalManagement_addItemLiability')" size="mini" prop="liability">
                            <el-input disabled :placeholder="$t('modal_humanCapitalManagement_addItemLiability')" v-model="formAddItem.liability"></el-input>
                        </el-form-item>
                        <el-form-item label-width="80px" label-position="left" :label="$t('modal_humanCapitalManagement_addItemPayxoftCode')" size="mini" prop="liability">
                            <el-input disabled :placeholder="$t('modal_humanCapitalManagement_addItemPayxoftCode')" v-model="formAddItem.payxoftCode"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="flex-end">
                    <el-form-item>
                        <el-button v-if="state === 'create'" @click="create('formAddItem')" class="modal__btn" type="primary" plain size="mini">{{$t('general_save')}}</el-button>
                        <el-button v-if="state === 'update'" @click="update('formAddItem', itemId)" class="modal__btn" type="primary" plain size="mini">{{$t('general_edit')}}</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </sweet-modal>
    </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios'
  export default {
    name: "HumanCapitalAddItemModal",
    components:{
      SweetModal
    },
    data(){
      return {
        type: null,
        state: 'create',
        itemId: null,
        schedules: ['Normal Day'],
        someDayList: ['Yes', 'No'],
        formAddItem:{
          type: 'Normal Day',
          hoursOrdinaryCode: null,
          name: null,
          description: null,
          // left
          hours: null,
          someDay: null,
          // right
          nameOfPayslip: null,
          rateType: null,
          multiplierOfHourlyRate: false,
          multiplyBy: null,
          taxType: null,
          expenditure: null,
          liability: null,
          payxoftCode: null,
        },
        rules: {
          type: [
            { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          hoursOrdinaryCode: [
            { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          name: [
            { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          hours: [
            { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          someDay: [
            { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        }
      }
    },
    methods:{
      async open(command){
         try {
           this.type = command;

           this.state = 'create';

           this.$refs.addHumanCapitalItemModal.open();

           const directories = await this.directories();

         } catch (err) {
           console.log(err)
         }
      },
      async openEdit(command, itemId) {
        try {
          this.type = command;
          this.state = 'update';
          this.itemId = itemId;

          const directories = await this.directories();

          const item = await this.item(itemId);

          this.$refs.addHumanCapitalItemModal.open();

        } catch (err) {
          console.log(err)
        }
      },
      directories(){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/workingHoursItem/directories?companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('response', response.data);
              loader.hide();
              resolve(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide();
              reject(error)
            });
        })
      },
      item(itemId){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/workingHoursItem/item?companyId=${this.$route.query.companyId}&itemId=${itemId}`)
            .then(response => {
              console.log('response', response.data);
              this.formAddItem.type = response.data.fields.fields.type;
              this.formAddItem.hoursOrdinaryCode = response.data.fields.fields.code;
              this.formAddItem.name = response.data.fields.fields.name;
              this.formAddItem.description = response.data.fields.fields.description;
              this.formAddItem.hours = response.data.fields.fields.hours;
              this.formAddItem.someDay = response.data.fields.fields.someDay;
              loader.hide();
              resolve(response.data.item)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide();
              reject(error)
            });
        })
      },
      create(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            const data = {
              fields: {
                type: this.formAddItem.type,
                code: this.formAddItem.hoursOrdinaryCode,
                name: this.formAddItem.name,
                description: this.formAddItem.description,
                hours: this.formAddItem.hours,
                someDay: this.formAddItem.someDay,
              }
            };
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/workingHoursItem/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                console.log('response', response.data);
                loader.hide();
                this.notification(this.$t('general_success'), this.$t('notification_humanCapitalItemkAdded'), "success");
                this.$emit('loadList');
                this.$refs.addHumanCapitalItemModal.close();
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide();
              });
          } else {
            console.log('not valid')
          }
        })
      },
      update(form, itemId) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            const data = {
              fields: {
                type: this.formAddItem.type,
                code: this.formAddItem.hoursOrdinaryCode,
                name: this.formAddItem.name,
                description: this.formAddItem.description,
                hours: this.formAddItem.hours,
                someDay: this.formAddItem.someDay,
              }
            };
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/workingHoursItem/update?companyId=${this.$route.query.companyId}&itemId=${itemId}`, data)
              .then(response => {
                console.log('response', response.data);
                loader.hide();
                this.notification(this.$t('general_success'), this.$t('notification_humanCapitalEditItem'), "success");
                this.$emit('loadList');
                this.$refs.addHumanCapitalItemModal.close();
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide();
              });
          } else {
            console.log('not valid')
          }
        })
      },
      close(){
        this.$refs['formAddItem'].resetFields();
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    }
  }
</script>

<style scoped>

</style>
